class VideoPlayer extends HTMLElement {
  constructor() {
    super()

    const videoPlayerElement = this
    const videoElement = videoPlayerElement.querySelector('video')

    const handleVideoState = () => {
      if (videoElement.paused) {
        videoElement.play()
      } else {
        videoElement.pause()
      }
    }

    videoPlayerElement.addEventListener('click', handleVideoState)
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('video-player') === undefined) {
  customElements.define('video-player', VideoPlayer)
}
